// Reforma UX §6.13 — helpers compartilhados do catálogo de Modelos LLM (admin).
import { ApiError, type CanonicalEffort, type LlmModel } from '@/lib/api';
import { fmtMoneyUSD } from '@/lib/format';

/** Ordem canônica dos níveis de reasoning (CanonicalEffort). */
export const EFFORT_LEVELS: CanonicalEffort[] = ['minimal', 'low', 'medium', 'high', 'xhigh', 'max'];

/**
 * Flags de auth com degrade graceful: enquanto o backend não expõe
 * `available_via_oauth`/`available_via_api_key` (pós-restart), deriva do status:
 * 'available_via_oauth' ⇒ só OAuth; senão ambos true.
 */
export function authFlags(m: LlmModel): { oauth: boolean; apiKey: boolean } {
  if (typeof m.available_via_oauth === 'boolean' || typeof m.available_via_api_key === 'boolean') {
    return {
      oauth: m.available_via_oauth ?? false,
      apiKey: m.available_via_api_key ?? false,
    };
  }
  if (m.status === 'available_via_oauth') return { oauth: true, apiKey: false };
  return { oauth: true, apiKey: true };
}

/** Reasoning habilitado = modelo tem níveis de effort suportados. */
export function hasReasoning(m: LlmModel): boolean {
  return (m.supported_effort_levels?.length ?? 0) > 0;
}

/** Formata custo USD/1M pt-BR ("US$ 3,00" | "—") — delega ao canonico fmtMoneyUSD. */
export function fmtCost(v: number | null | undefined): string {
  return fmtMoneyUSD(v);
}

/** Mensagem de erro amigável p/ mutations (403 de não-admin → toast graceful). */
export function mutationErrorMessage(err: unknown, action: string): string {
  if (err instanceof ApiError) {
    if (err.status === 403) return `Sem permissão para ${action} — apenas admins podem gerenciar modelos.`;
    return `Falha ao ${action}: ${err.message}`;
  }
  return `Falha ao ${action}. Tente novamente.`;
}
